import script from "./PersonalTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalTable.vue?vue&type=script&setup=true&lang=js"

import "./PersonalTable.vue?vue&type=style&index=0&id=34877142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34877142"]])

export default __exports__